// Lightweight geo helpers for Tocoa, Colón (Honduras).
// Known neighbourhoods get real coordinates; anything else gets a stable
// deterministic point near the town centre so the map never looks empty.

export const TOCOA = { lat: 15.6566, lng: -86.0055 };

const PLACES = [
  [/parque central|frente al parque|el centro|centro/i, { lat: 15.65562, lng: -86.00605 }],
  [/las flores/i, { lat: 15.66050, lng: -86.00120 }],
  [/18 de septiembre/i, { lat: 15.65120, lng: -86.00980 }],
  [/san isidro/i, { lat: 15.66240, lng: -86.00830 }],
  [/av\.?\s*principal|avenida principal/i, { lat: 15.65800, lng: -86.00400 }],
  [/farmacia sim/i, { lat: 15.65920, lng: -86.00250 }],
  [/tienda el .?xito/i, { lat: 15.65710, lng: -86.00310 }],
  [/panader/i, { lat: 15.65440, lng: -86.00720 }],
  [/pollo norte/i, { lat: 15.65510, lng: -86.00490 }],
  [/pizza tocoa/i, { lat: 15.66080, lng: -86.00180 }],
  [/caf. del parque/i, { lat: 15.65580, lng: -86.00640 }],
  [/burgers tocoa/i, { lat: 15.65160, lng: -86.00910 }],
  [/tacos el amigo/i, { lat: 15.66200, lng: -86.00380 }],
  [/sushi tocoa/i, { lat: 15.65970, lng: -85.99980 }],
  [/cargo expreso|encomiendas|oficina/i, { lat: 15.65380, lng: -86.01020 }],
  [/hospital|cesamo|cl.nica/i, { lat: 15.66310, lng: -86.00600 }],
  [/mercado/i, { lat: 15.65330, lng: -86.00440 }],
];

const hash = (s) => {
  let h = 2166136261;
  for (let i = 0; i < s.length; i += 1) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
  return Math.abs(h);
};

// Deterministic coordinate for a free-text place / address.
export const geocode = (text) => {
  const s = (text || '').toString().trim();
  if (!s) return { ...TOCOA };
  for (const [re, coords] of PLACES) if (re.test(s)) return { ...coords };
  const h = hash(s.toLowerCase());
  return {
    lat: TOCOA.lat + (((h % 2000) / 2000) - 0.5) * 0.012,
    lng: TOCOA.lng + ((((h >> 11) % 2000) / 2000) - 0.5) * 0.014,
  };
};

export const lerp = (a, b, t) => ({ lat: a.lat + (b.lat - a.lat) * t, lng: a.lng + (b.lng - a.lng) * t });

export const distanceKm = (a, b) => {
  if (!a || !b) return 0;
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const la1 = (a.lat * Math.PI) / 180;
  const la2 = (b.lat * Math.PI) / 180;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
};

// Ignore positions that are clearly outside the Tocoa service area (e.g. a
// device testing the demo from another country) so the ETA stays realistic.
export const inServiceArea = (p) => !!p && Number.isFinite(p.lat) && distanceKm(p, TOCOA) <= 60;

export const prettyDistance = (km) => (km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`);

// Ignore positions older than 5 minutes (driver app closed / stale demo data)
export const isFresh = (loc, ms = 300000) => {
  if (!loc || !Number.isFinite(loc.lat)) return false;
  if (!loc.updatedAt) return true;
  return Date.now() - new Date(loc.updatedAt).getTime() < ms;
};

// ~22 km/h average scooter speed in town + 2 min buffer
export const etaMinutes = (km) => Math.max(1, Math.round((km / 22) * 60) + 2);
